export default "__VITE_ASSET__BphrlhWK__"